import { receiptServices } from "../../../services/api/receipts.endpoints";
import {
  setAllCompanies,
  setAllCurrencies,
  setFailedReceipts,
  setFailedReceiptsPayload,
  setFailedReceiptStatus,
  setFinancialMonthlyEarningsData,
  setPairingRate,
  setReceiptData,
} from "../../../features/financeReceiptSlice";
import {
  setAllUsers,
  setDisplayErrorSnackBar,
} from "../../../features/userSlice";
import store from "../../../store";
// import { buildPartialSuccessMessage } from "../../../components/Finance/ProvidersExpenses/Receipts/helpers/funcs/buildPartialSucMsg";

async function getAllReceiptData(
  oauthTokenHeader: any,
  from_date: any,
  to_date: any
) {
  try {
    const response = await receiptServices.getReceiptData(
      oauthTokenHeader,
      from_date,
      to_date
    );
    if (!response || typeof response.status !== "number") {
      throw new Error("Invalid response from server");
    }

    if (response.status === 204) {
      store.dispatch(setReceiptData([]));
      return [];
    }

    if (response.status === 200) {
      const data = response?.data?.data ?? [];
      store.dispatch(setReceiptData(data));
      return data;
    }

    throw new Error(`Unexpected status code: ${response.status}`);
  } catch (error: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          error?.parsedText || "Something went wrong while fetching receipts.",
        type: "error",
      })
    );
  }
}

async function getAllCurrencies(oauthTokenHeader: any) {
  try {
    const response = await receiptServices.getAllCurrencies(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get currencies");
    } else {
      store.dispatch(setAllCurrencies(response?.data?.data));
    }
  } catch (error: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          error?.parsedText ||
          "Something went wrong while fetching currencies.",
        type: "error",
      })
    );
  }
}

async function getAllCompanies(oauthTokenHeader: any) {
  try {
    const response = await receiptServices.getAllCompanies(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get companies");
    } else {
      store.dispatch(setAllCompanies(response?.data?.data));
    }
  } catch (error: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          error?.parsedText || "Something went wrong while fetching companies.",
        type: "error",
      })
    );
  }
}

async function getPairingRate(
  oauthTokenHeader: string,
  QUERY_ID: string,
  from_date: any,
  to_date: any,
  website_shared_uid: any
) {
  try {
    const response = await receiptServices.getPairingRate(
      oauthTokenHeader,
      QUERY_ID,
      from_date,
      to_date,
      website_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get pairing rate");
    } else {
      store.dispatch(setPairingRate(response?.data?.data));
    }
  } catch (error: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: error?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function createReceipt(oauthTokenHeader: string, data: any) {
  try {
    const response = await receiptServices.createReceipt(
      oauthTokenHeader,
      data
    );
    if (!response || ![201, 207].includes(response.status)) {
      throw new Error("Failed to create receipt");
    }

    // store.dispatch(
    //   setDisplayErrorSnackBar({
    //     message: response?.data?.data?.reason || "Receipt created successfully",
    //     type: "success",
    //   })
    // );
    if (response.status === 207) {
      const results = response?.data?.data ?? [];

      // const warningMessage = buildPartialSuccessMessage(results);

      // store.dispatch(
      //   setDisplayErrorSnackBar({
      //     message: warningMessage,
      //     type: "warning",
      //   })
      // );
      store.dispatch(setFailedReceiptStatus(true));
      store.dispatch(setFailedReceipts(results));
      store.dispatch(setFailedReceiptsPayload(data));
    }

    return response;
  } catch (error: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: error?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function editReceipt(
  oauthTokenHeader: string,
  data: any,
  receipt_shared_uid: any
) {
  try {
    const response = await receiptServices.editReceipt(
      oauthTokenHeader,
      data,
      receipt_shared_uid
    );
    if (!response || response.status !== 200) {
      throw new Error("Failed to update receipt");
    }
    store.dispatch(
      setDisplayErrorSnackBar({
        message: response?.data?.data?.reason || "Receipt Updated successfully",
        type: "success",
      })
    );
    return response;
  } catch (error: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: error?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}
async function deleteReceipt(oauthTokenHeader: any, receipt_shared_uid: any) {
  try {
    const response = await receiptServices.deleteReceipt(
      oauthTokenHeader,
      receipt_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to update comments");
    } else {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Delete Successfull",
          type: "success",
        })
      );
    }
  } catch (error: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: error?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

//Get all users for receipts
async function getAllUserList(oauthTokenHeader: any) {
  try {
    const response = await receiptServices.getAllUsers(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get users");
    } else {
      store.dispatch(setAllUsers(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

//Get financial monthly earnings for a company
async function getFinancialMonthlyEarnings(
  oauthTokenHeader: any,
  company_shared_uid: any
) {
  try {
    const response = await receiptServices.getFinancialMonthlyEarnings(
      oauthTokenHeader,
      company_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get financial monthly earnings");
    } else {
      store.dispatch(setFinancialMonthlyEarningsData(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function createFinancialMonthlyEarnings(
  oauthTokenHeader: any,
  data: any
) {
  try {
    const response = await receiptServices.createFinancialMonthlyEarnings(
      oauthTokenHeader,
      data
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to create financial monthly earnings");
    } else {
      store.dispatch(
        setDisplayErrorSnackBar({
          message:
            response?.data?.data?.reason ||
            "Financial Monthly Earnings Link created successfully",
          type: "success",
        })
      );
    }
    return response;
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function deleteFinancialMonthlyEarnings(
  oauthTokenHeader: any,
  data: any
) {
  try {
    const response = await receiptServices.deleteFinancialMonthlyEarnings(
      oauthTokenHeader,
      data
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to delete financial monthly earnings");
    } else {
      store.dispatch(
        setDisplayErrorSnackBar({
          message:
            response?.data?.data?.reason ||
            "Financial Monthly Earnings Link deleted successfully",
          type: "success",
        })
      );
    }
    return response;
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

export const ReceiptsEndPointLogic = {
  getAllReceiptData,
  getAllCurrencies,
  getPairingRate,
  getAllCompanies,
  createReceipt,
  editReceipt,
  deleteReceipt,
  getAllUserList,
  getFinancialMonthlyEarnings,
  createFinancialMonthlyEarnings,
  deleteFinancialMonthlyEarnings,
};
